import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { REGION_VALUES, type Region } from '@/shared/utils/regions';

export const useRegionOptions = (): { value: Region; label: string }[] => {
  const { t } = useTranslation();
  return useMemo(
    () => REGION_VALUES.map((v) => ({ value: v, label: t(`regions.${v}`) })),
    [t],
  );
};
